import React, { useState, createContext } from 'react';

export const HsaReimbursementFormContext = createContext({
  amount: '',
  merchant: '',
  from: '',
  description: '',
  external_bank_acct: {},
  setFormInfo: (v: {
    amount: string;
    merchant: string;
    from: string;
    description: string;
    external_bank_acct: {
      bank_account_name?: string;
      id?: string;
      last4?: string;
      status?: string;
    };
  }) => {},
});

export const HsaReimbursementFormContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [form_info, setFormInfo] = useState({
    amount: '',
    merchant: '',
    from: '',
    description: '',
    external_bank_acct: {},
  });

  return (
    <HsaReimbursementFormContext.Provider value={{ ...form_info, setFormInfo }}>
      {children}
    </HsaReimbursementFormContext.Provider>
  );
};

export default HsaReimbursementFormContext;
